import { render, staticRenderFns } from "./complateInfs.vue?vue&type=template&id=4a325d8e&scoped=true&"
import script from "./complateInfs.vue?vue&type=script&lang=js&"
export * from "./complateInfs.vue?vue&type=script&lang=js&"
import style0 from "./complateInfs.vue?vue&type=style&index=0&id=4a325d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a325d8e",
  null
  
)

export default component.exports